import React, { useState } from 'react';
import { useSelector } from 'react-redux';


// import useStyles from './useStyles';

import { Button, DialogTitle, DialogContent, DialogActions, Dialog, IconButton, Select, MenuItem } from '@mui/material'
// import Button from '@mui/material/Button';
// import DialogTitle from '@mui/material/DialogTitle';
// import DialogContent from '@mui/material/DialogContent';
// import DialogActions from '@mui/material/DialogActions';
// import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

import SaveStatus from '../SaveStatus';

function ModalChangeStatus(props) {
  const {
    onClose,
    saver = () => { },
    progressObj,  //!!!!!!!!!!!!!!!!!!!!!
    open,
    docId,
    documentName,
    selectOptions = []
    // ...other
  } = props;

  const [selectedStatus, setSelectedStatus] = useState(selectOptions?.[0]?.id);

  //попробуем новый вариант синтаксиса
  const changeStatusDocument = useSelector(s => (s?.service?.Api?.changeStatusDocument || (() => { })))
  const getSingleDocument = useSelector(s => (s?.service?.Api?.getSingleDocument || (() => { })))
  const setDocumentData = useSelector(s => (s?.service?.Api?.actions?.setDocumentData || (() => { })))
  const setSingleDocument = useSelector(s => (s?.service?.Api?.actions?.setSingleDocument || (() => { })))

  const changingStatusDocument = useSelector(s => (s?.api?.changingStatusDocument))
  const singleDocument = useSelector(s => (s?.api?.singleDocument))
  const documentData = useSelector(s => (s?.api?.documentData))

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    changeStatusDocument({ docId: documentName, id: docId, status: selectedStatus })
  };

  const postChangeStatus = () => {
    getSingleDocument({ docId: documentName, id: docId })
    // update()
    // onClose()
  }
  const onLoadNewData = () => {
    if(singleDocument?.data){
      const { data = [] } = documentData;
      const newData = data.map((row) => {
        if (row?.id?.rawValue === docId) {
          //заменяем документ
          return singleDocument.data
        } else {
          //возвращаем без изменений
          return row
        }
      })
      const newDocumentData = { ...documentData, data: newData }
      setDocumentData(newDocumentData)
      setSelectedStatus(singleDocument.data?.availableStatuses?.rawValue?.[0])
      setSingleDocument()
      onClose()
    }
  }

  const disableActions=postChangeStatus?.loading || onLoadNewData?.loading

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: "80%" } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>Изменение статуса</DialogTitle>
      <IconButton
        onClick={handleCancel}
        disabled={disableActions}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent >
        <SaveStatus dataObj={changingStatusDocument} errShowTime={6000} postSuccessAction={postChangeStatus} />
        <SaveStatus dataObj={singleDocument} successShowTime={500} errShowTime={6000} postSuccessAction={onLoadNewData} />
        <Select
          // labelId="demo-simple-select-label"
          id="statusSelector"
          fullWidth
          value={selectedStatus}
          // label="Age"
          size='small'
          onChange={(e) => setSelectedStatus(e.target.value)}
        >
          {selectOptions.map(({ id, label }) => <MenuItem value={id}>{label}</MenuItem>)}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} variant="contained" color="success" startIcon={<ExitToAppIcon />} disabled={disableActions}>
          Изменить
        </Button>
        <Button onClick={handleCancel} variant="outlined" color="primary" disabled={disableActions}>
          Отмена
        </Button>
      </DialogActions>
    </Dialog>

  );
}



export default ModalChangeStatus;
